import React, { useState, useEffect } from 'react';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import 'react-awesome-slider/dist/custom-animations/cube-animation.css';

function Portfolio() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const petAdoptionSlides = [
    "images/projects/pet_adoption/pet-adoption-eccce.web.app_home.png",
    "images/projects/pet_adoption/pet-adoption-eccce.web.app_ (2).png",
    "images/projects/pet_adoption/pet-adoption-eccce.web.app_donation.png", 
  ];
  const ProductPulseSlides = [
    "images/projects/product_pulse/product-pulse-7aeac.web.app_login.png",
    "images/projects/product_pulse/product-pulse-7aeac.web.app_queries.png",
    "images/projects/product_pulse/product-pulse-7aeac.web.app_login_my_recommendation.png",
  ];
  const CraftifyCreationsSlides = [
    "images/projects/craftify_creations/craftify-creations.web.app_.png",
    "images/projects/craftify_creations/craftify-creations.web.app_ all_craftify.png",
    "images/projects/craftify_creations/craftify-creations.web.app_ add_items.png"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % petAdoptionSlides.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [petAdoptionSlides.length]);

  return (
    <div className="w-[90%] lg:w-full mx-auto bg-gray-100 py-8 p-2 lg:p-2">
      <div className="text-center mb-12">
        <h3 className="text-3xl font-bold text-center m-12">
          <span className='text-center text-white'>Latest Projects</span>
        </h3>
      </div>
      <div className="portfolio-box w-full lg:max-w-5xl gap-12">
        {/* Project 1 */}
        <div className="project-card bg-white p-4 w-full lg:w-full rounded-lg shadow-md relative mb-4 lg:mb-6">
          <div className="image-container flex p-1 overflow-hidden rounded-lg relative">
          {/* <AwesomeSlider animation="cubeAnimation">
              <div>
                <img
                  src="images/projects/pet_adoption/pet-adoption-eccce.web.app_home.png"
                  alt="Pet Adoption"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              <div>
                <img
                  src="images/projects/pet_adoption/pet-adoption-eccce.web.app_ (2).png"
                  alt="Pet Adoption"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              <div>
                <img
                  src="images/projects/pet_adoption/pet-adoption-eccce.web.app_donation.png"
                  alt="Pet Adoption"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              </AwesomeSlider> */}
               <AwesomeSlider
            animation="cubeAnimation"
            selected={currentIndex}
            className="w-full h-full"
          >
            {petAdoptionSlides.map((slide, index) => (
              <div key={index} className="w-full h-full">
                <img src={slide} alt={`Slide ${index + 1}`} className="object-cover p-3 w-full h-auto max-h-[600px] " />
              </div>
            ))}
          </AwesomeSlider>
          </div>
          <div className="project-info bg-green-50 p-4 relative -top-8 rounded-t-3xl">
            <h4 className="project-title text-2xl font-semibold">Pet Adoption</h4>
            <p className="project-description text-xl mt-2">
              A MERN stack-based platform for adopting pets, allowing users to browse pets available for adoption and submit adoption requests. Features include donation campaigns and categorized pet listings.
            </p>
            <ul className="list-disc ml-5 text-xl mt-2">
              <li>Pet Listing: Enables users to browse pets available for adoption and submit adoption requests.</li>
              <li>Donation Campaigns: Users can contribute donations to specific pets through Stripe payment system.</li>
              <li>Navbar, Banner Section, Pets Category Section, Call to Action Section, About Us Section.</li>
            </ul>
            <p className="text-xl mt-2">Technologies: HTML, CSS, Tailwind CSS, React, JavaScript, MongoDB, Express.js, JWT, Firebase Authentication, Git, Tanstack Table, Tanstack Query, Flowbite, Tiptap.</p>
            <div className='flex flex-col lg:flex-row justify-between w-[70%] py-12 gap-4 lg:w-full'>
              <div className='project-btn-container m-4'>
                <a href="https://pet-adoption.web.app" className="project-btn">
                  View Project
                  <span className="ml-2 transition-transform duration-300 transform group-hover:rotate-45 text-xl">→</span>
                </a>
              </div>
              <div className='project-btn-container m-4'>
                <a href="https://github.com/Faysalgreen35/Pet-Adoption-Client" className="project-btn">
                  Client Code
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
              <div className='project-btn-container m-4'>
                <a href="https://github.com/Faysalgreen35/Pet-Adoption-Server" className="project-btn">
                  Server Code
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Project 2 */}
        <div className="project-card bg-white p-4 w-full lg:w-full rounded-lg shadow-md relative mb-4 lg:mb-6">
          <div className="image-container flex p-1 overflow-hidden rounded-lg relative">
          {/* <AwesomeSlider animation="cubeAnimation">
              <div>
                <img
                  src="images/projects/product_pulse/product-pulse-7aeac.web.app_login.png"
                  alt="ProductPulse"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              <div>
                <img
                  src="images/projects/product_pulse/product-pulse-7aeac.web.app_login_my_recommendation.png"
                  alt="ProductPulse"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              <div>
                <img
                  src="images/projects/product_pulse/product-pulse-7aeac.web.app_queries.png"
                  alt="ProductPulse"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              </AwesomeSlider> */}
          {/* <AwesomeSlider
            animation="cubeAnimation"
            selected={currentIndex}
            className="w-full h-full"
          >
            {ProductPulseSlides.map((slide, index) => (
              <div key={index} className="w-full h-full">
                <img src={slide} alt={`Slide ${index + 1}`} className="w-full h-full mt-0 lg:mt-24 p-12 object-cover    " />
              </div>
            ))}
          </AwesomeSlider> */}
          <AwesomeSlider
                animation="cubeAnimation"
                selected={currentIndex}
                className="w-full mt-4"
              >
                {ProductPulseSlides.map((slide, index) => (
                  <div key={index} className="flex items-center justify-center">
                    <img src={slide} alt={`Slide ${index + 1}`} className="object-cover p-3 w-full h-auto max-h-[600px]" />
                  </div>
                ))}
              </AwesomeSlider>
          </div>
          <div className="project-info bg-green-50 p-4 relative -top-8 rounded-t-3xl">
            <h4 className="project-title text-3xl font-semibold">ProductPulse</h4>
            <p className="project-description text-xl mt-2">
              A MERN stack-based platform revolutionizing product interaction, enabling users to explore, share, and collaborate on insights. Features include real-time user reviews and personalized recommendations.
            </p>
            <ul className="list-disc ml-5 text-xl mt-2">
              <li>Real-time user reviews</li>
              <li>Personalized recommendations</li>
              <li>Interactive product insights</li>
            </ul>
            <p className="text-xl mt-2">Technologies: MongoDB, Express.js, React, Node.js</p>
            <div className='flex flex-col lg:flex-row justify-between w-[70%] py-12 gap-4 lg:w-full'>
              <div className='project-btn-container m-4'>
                <a href="https://product-pulse-7aeac.web.app" className="project-btn">
                  View Project
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
              <div className='project-btn-container m-4'>
                <a href="https://github.com/Faysalgreen35/ProductPulse-Client" className="project-btn">
                  Client Code
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
              <div className='project-btn-container m-4'>
                <a href="https://github.com/Faysalgreen35/ProductPulse-server" className="project-btn">
                  Server Code
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>

         

        {/* Project 3 */}
        <div className="project-card bg-white p-4 w-full lg:w-full rounded-lg shadow-md relative mb-4 lg:mb-6">
          <div className="image-container flex p-1 overflow-hidden rounded-lg relative">
          {/* <AwesomeSlider animation="cubeAnimation">
              <div>
                <img
                  src="images/projects/craftify_creations/craftify-creations.web.app_.png"
                  alt="Craftify Creations"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              <div>
                <img
                  src="images/projects/craftify_creations/craftify-creations.web.app_ all_craftify.png"
                  alt="Craftify Creations"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              <div>
                <img
                  src="images/projects/craftify_creations/craftify-creations.web.app_ add_items.png"
                  alt="Craftify Creations"
                  className="project-image w-full h-56 object-cover transition-transform duration-300"
                />
              </div>
              </AwesomeSlider> */}
               <AwesomeSlider
            animation="cubeAnimation"
            selected={currentIndex}
            className="w-full h-full"
          >
            {CraftifyCreationsSlides.map((slide, index) => (
              <div key={index} className="w-full h-full">
                <img src={slide} alt={`Slide ${index + 1}`} className="object-cover p-3 w-full h-auto max-h-[600px] " />
              </div>
            ))}
          </AwesomeSlider>
          </div>
          <div className="project-info bg-green-50 p-4 relative -top-8 rounded-t-3xl">
            <h4 className="project-title text-2xl font-semibold">Craftify Creations</h4>
            <p className="project-description text-xl mt-2">
              A platform for exploring painting and drawing, allowing users to unleash creativity through various techniques. Features include custom design creation and the ability to showcase artworks.
            </p>
            <ul className="list-disc ml-5 text-xl mt-2">
              <li>Custom design creation</li>
              <li>Showcase artworks</li>
              <li>Explore various techniques</li>
            </ul>
            <p className="text-xl mt-2">Technologies: React, Firebase, Tailwind CSS</p>
            <div className='flex flex-col lg:flex-row justify-between w-[70%] py-12 lg:w-full'>
              <div className='project-btn-container m-4'>
                <a href="https://craftify-creations.web.app/" className="project-btn">
                  View Project
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
              <div className='project-btn-container m-4'>
                <a href="https://github.com/Faysalgreen35/Craftify-Creations-Client" className="project-btn">
                  Client Code
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
              <div className='project-btn-container m-4'>
                <a href="https://github.com/Faysalgreen35/Craftify-Creations-Server" className="project-btn">
                  Server Code
                  <span className="ml-2 transition-margin-left duration-300">→</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Education Section */}
      <div className="w-[100%] lg:w-full mt-12 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg shadow-md px-2 lg:px-8">
        <h3 className="text-3xl lg:text-5xl font-bold text-center mb-4">Education</h3>
        <div className="bg-white rounded-lg shadow-md p-4 lg:p-8">
          <div className="mb-4">
            <h2 className="text-lg lg:text-3xl font-semibold text-gray-800">BSc in Computer Science</h2>
            <p className="text-sm font-semibold lg:text-3xl text-gray-700">Green University of Bangladesh / 2016 - 2020</p>
            <p className="text-l lg:text-xl text-gray-700 mt-2">Relevant coursework: Web Development, Database Management, Software Engineering.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;

// import React from 'react';
// // import arrow from 'images/projects/Arrow3.png'
// function Portfolio() {
//   return (
//     <div className=" w-[90%] lg:w-full mx-auto bg-gray-100 py-8 p-2 lg:p-2 bg-gradient-to-r from-blue-500 to-purple-500">
//       <div className="  text-center mb-12">
//         <h3 className="text-3xl font-bold text-center m-12">
//           <span className='text-center text-white'>Latest Projects</span>
//         </h3>
//       </div>
//       <div className=" portfolio-box w-full lg:max-w-5xl gap-12 ">
//          {/* Project 3 */}
//          <div className="project-card bg-white p-4 w-full lg:w-full rounded-lg shadow-md relative   mb-4 lg:mb-6mb-3 lg:mb-6">
//           <div className="image-container flex p-1 overflow-hidden rounded-lg relative">
//             <img
//               src="images/projects/pet_adoption/pet-adoption-eccce.web.app_home.png"
//               alt="Pet Adoption"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//             <img
//               src="images/projects/pet_adoption/pet-adoption-eccce.web.app_ (2).png"
//               alt="Pet Adoption"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//             <img
//               src="images/projects/pet_adoption/pet-adoption-eccce.web.app_donation.png"
//               alt="Pet Adoption"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//           </div>
//           <div className="project-info bg-green-50 p-4 relative -top-8 rounded-t-3xl">
//             <h4 className="project-title text-2xl font-semibold">Pet Adoption</h4>
//             <p className="project-description text-xl mt-2">
//               A MERN stack-based platform for adopting pets, allowing users to browse pets available for adoption and submit adoption requests. Features include donation campaigns and categorized pet listings.
//             </p>
//             <ul className="list-disc ml-5 text-xl mt-2">
//               <li>Pet Listing: Enables users to browse pets available for adoption and submit adoption requests.</li>
//               <li>Donation Campaigns: Users can contribute donations to specific pets through Stripe payment system.</li>
//               <li>Navbar, Banner Section, Pets Category Section, Call to Action Section, About Us Section.</li>
//             </ul>
//             <p className="text-xl mt-2">Technologies: HTML, CSS, Tailwind CSS, React, JavaScript, MongoDB, Express.js, JWT, Firebase Authentication, Git, Tanstack Table, Tanstack Query, Flowbite, Tiptap.</p>
//            <div className='flex flex-col lg:flex-row justify-between w-[70%] py-12 gap-4 lg:w-full '>
//            <div className='project-btn-container m-4'>
//             <a
//               href="https://pet-adoption.web.app"
//               className=" project-btn"
//             >
//               View Project
//               <span className="ml-2 transition-transform duration-300 transform group-hover:rotate-45 text-xl">→</span>
//             </a>
//             </div>

//            <div className='project-btn-container m-4'>  <a
//               href="https://github.com/Faysalgreen35/Pet-Adoption-Client"
//               className=" project-btn"
//             >
//               Client Code
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a></div>
//            <div className='project-btn-container m-4'>  
//              <a
//               href="https://github.com/Faysalgreen35/Pet-Adoption-Server"
//               className=" project-btn"
//             >
//               Server Code
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a></div>
          
         
//            </div>
//           </div>
//         </div>
//         {/* Project 1 */}
//         <div className="project-card bg-white p-4 w-full  lg:w-full rounded-lg shadow-md relative  mb-4 lg:mb-6">
//         <div className="image-container flex p-1 overflow-hidden rounded-lg relative mx-6">
//             <img
//               src="images/projects/product_pulse/product-pulse-7aeac.web.app_login.png"
//               alt="ProductPulse"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//             <img
//               src="images/projects/product_pulse/product-pulse-7aeac.web.app_login_my_recommendation.png"
//               alt="ProductPulse"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//             <img
//               src="images/projects/product_pulse/product-pulse-7aeac.web.app_queries.png"
//               alt="ProductPulse"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//           </div>
//           <div className="project-info bg-green-50 p-4 relative -top-8 rounded-t-3xl">
//             <h4 className="project-title text-3xl font-semibold">ProductPulse</h4>
//             <p className="project-description text-xl mt-2">
//               A MERN stack-based platform revolutionizing product interaction, enabling users to explore, share, and collaborate on insights. Features include real-time user reviews and personalized recommendations.
//             </p>
//             <ul className="list-disc ml-5 text-xl mt-2">
//               <li>Real-time user reviews</li>
//               <li>Personalized recommendations</li>
//               <li>Interactive product insights</li>
//             </ul>
//             <p className="text-xl mt-2">Technologies: MongoDB, Express.js, React, Node.js</p>
//             <div className='flex flex-col lg:flex-row justify-between w-[70%] py-12 gap-4 lg:w-full  '>
//             <div className='project-btn-container m-4'>  
//           <a
//               href="https://product-pulse-7aeac.web.app"
//               className=" project-btn"
//             >
//               View Project
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a>
//             </div>
//             <div className='project-btn-container m-4'>  
//             <a
//               href="https://github.com/Faysalgreen35/ProductPulse-Client"
//               className=" project-btn"
//             >
//               Client Code
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a>
//             </div>
//             <div className='project-btn-container m-4'>  
//             <a
//               href="https://github.com/Faysalgreen35/ProductPulse-server"
//               className=" project-btn"
//             >
//               Server Code
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a>

//           </div>
//           </div>
            
//           </div>
//         </div>

//         {/* Project 2 */}
//         <div className="project-card bg-white p-4 w-full  lg:w-full rounded-lg shadow-md relative  mb-4 lg:mb-6">
//         <div className="image-container flex p-1 overflow-hidden rounded-lg relative">
//             <img
//               src="images/projects/craftify_creations/craftify-creations.web.app_.png"
//               alt="Craftify Creations"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//             <img
//               src="images/projects/craftify_creations/craftify-creations.web.app_ all_craftify.png"
//               alt="Craftify Creations"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//             <img
//               src="images/projects/craftify_creations/craftify-creations.web.app_ add_items.png"
//               alt="Craftify Creations"
//               className="project-image w-1/3 h-56 object-cover transition-transform duration-300"
//             />
//           </div>
//           <div className="project-info bg-green-50 p-4 relative -top-8 rounded-t-3xl">
//             <h4 className="project-title text-2xl font-semibold">Craftify Creations</h4>
//             <p className="project-description text-xl mt-2">
//               A platform for exploring painting and drawing, allowing users to unleash creativity through various techniques. Features include custom design creation and the ability to showcase artworks.
//             </p>
//             <ul className="list-disc ml-5 text-xl mt-2">
//               <li>Custom design creation</li>
//               <li>Showcase artworks</li>
//               <li>Explore various techniques</li>
//             </ul>
//             <p className="text-xl mt-2">Technologies: React, Firebase, Tailwind CSS</p>
//             <div className='flex flex-col lg:flex-row justify-between w-[70%] py-12 lg:w-full '>
//             <div className='project-btn-container m-4'>  
//            <a
//               href="https://craftify-creations.web.app/"
//               className=" project-btn"
//             >
//               View Project
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a>
//             </div>
//             <div className='project-btn-container m-4'>  
//             <a
//               href="https://github.com/Faysalgreen35/Craftify-Creations-Client"
//               className=" project-btn"
//             >
//               Client Code
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a>
//             </div>
//             <div className='project-btn-container m-4'>  
//             <a
//               href="https://github.com/Faysalgreen35/Craftify-Creations-Server"
//               className=" project-btn"
//             >
//               Server Code
//               <span className="ml-2 transition-margin-left duration-300">→</span>
//             </a>
//            </div>
//            </div>
           
//           </div>
//         </div>

       

//       </div>

//       {/* Education Section */}
//       <div className=" w-[100%] lg:w-full mt-12 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg shadow-md px-2  lg:px-8">
//           <h3 className="text-3xl lg:text-5xl font-bold text-center mb-4">
//             Education
//           </h3>
//           <div className="bg-white rounded-lg shadow-md p-4 lg:p-8">
//             <div className="mb-4">
//               <h2 className="text-lg lg:text-3xl font-semibold text-gray-800">
//                 BSc in Computer Science
//               </h2>
//               <p className="text-sm font-semibold lg:text-3xl   text-gray-700">
//                 Green University of Bangladesh / 2016 - 2020
//               </p>
//               <p className="text-l lg:text-xl text-gray-700 mt-2">
//                 Relevant coursework: Web Development, Database Management, Software Engineering.
//               </p>
//             </div>
//           </div>
//         </div>
       
      
    
//     </div>
//   );
// }

// export default Portfolio;
 